import { useEffect } from "react";
import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import Login from "./pages/Login"; // 로그인
import Dashboard from "./pages/Dashboard"; // 대시보드
import User from "./pages/User"; // 회원관리
import UserDetail from "./pages/UserDetail"; // 회원 상세
import Notice from "./pages/Notice"; // 공지사항
import NoticeDetail from "./pages/NoticeDetail"; // 공지사항 상세 및 작성
import Material from "./pages/Material"; // 자료관리
import MaterialDetail from "./pages/MaterialDetail"; // 자료 상세
import Setting from "./pages/Setting"; // 설정
import TutorialManager from "./pages/TutorialManager"; // 튜토리얼 관리
import NotFound from "./pages/NotFound";
import BannerManager from "./pages/BannerManager";

const IntroRedirect = () => {
  useEffect(() => {
    window.location.replace("/intro.html");
  }, []);

  return null;
};

const Router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <IntroRedirect /> },
      { path: "login", element: <Login /> },
      { path: "dashboard", element: <Dashboard /> },
      { path: "user", element: <User /> },
      { path: "user/detail/:idx", element: <UserDetail /> },
      { path: "notice", element: <Notice /> },
      { path: "notice/detail/:idx", element: <NoticeDetail /> },
      { path: "notice/detail/:idx/:add", element: <NoticeDetail /> },
      { path: "tutorial", element: <TutorialManager /> },
      { path: "material", element: <Material /> },
      { path: "material/detail/:idx", element: <MaterialDetail /> },
      { path: "Setting", element: <Setting /> },
      { path: "banner", element: <BannerManager /> },
    ],
    errorElement: <NotFound />
  }
]);

export default Router;
